export const sliderItems = [
	{
		id: 1,
		img: "https://img.freepik.com/free-photo/portrait-beautiful-cute-happy-sweet-smiling-blonde-woman-woman-holding-her-hands-big-shopping-colorful-bags-hipster-clothes-isolated-white_158538-14597.jpg?w=740&t=st=1688459553~exp=1688460153~hmac=36b7436926249d54a65551d166b2c05697d8968b2ded0e0974e4c745d816d757",
		title: "Summer Sale",
		desc: "Get Flat 30% OFF on NEW ARRIVALS.",
		bg: "ffffff",
	},
	{
		id: 2,
		img: "https://i.ibb.co/DG69bQ4/2.png",
		title: "AUTUMN COLLECTION",
		desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
		bg: "fcf1ed",
	},
	{
		id: 3,
		img: "https://i.ibb.co/cXFnLLV/3.png",
		title: "LOUNGEWEAR LOVE",
		desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
		bg: "fbf0f4",
	},
];

export const categories = [
	{
		id: 1,
		img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
		title: "THE MEN.",
		cat: "men",
	},
	{
		id: 2,
		img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
		title: "WOMEN LOVE! ",
		cat: "women",
	},
	{
		id: 3,
		img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
		title: "JACKETS",
		cat: "jacket",
	},
];

export const popularProducts = [
	{
		id: 1,
		img: "https://pngimg.com/uploads/kimono/kimono_PNG47.png",
	},
	{
		id: 2,
		img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
	},
	{
		id: 3,
		img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
	},
	{
		id: 4,
		img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
	},
	{
		id: 5,
		img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
	},
	{
		id: 6,
		img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
	},
	{
		id: 7,
		img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
	},
	{
		id: 8,
		img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
	},
];
